const getContextUUID = (result) => result?.context_uuid ?? undefined;
const getFrontendContextUUID = (result) => result?.frontend_context_uuid ?? undefined;
const getThreadTitle = (result) => result?.thread_title ?? '';
const getFirstQuery = (result) => result?.query_str ?? undefined;
const getThreadFocus = (result) => result?.search_focus ?? undefined;
const getThreadSources = (result) => result.sources?.sources ?? undefined;
const getThreadAuthorId = (result) => result?.author_id ?? undefined;
const getThreadAuthorUsername = (result) => result?.author_username ?? undefined;
const getThreadAuthorImage = (result) => result?.author_image ?? undefined;
const getThreadParentInfo = (result) => {
    if (result.parent_info) {
        return result.parent_info;
    }
    return undefined;
};
const getThreadMode = (result) => result?.mode ?? null;
const getThreadPersonalized = (result) => result?.personalized ?? undefined;
const getThreadCollection = (result) => result?.collection_info ?? undefined;
const getThreadBookmarkState = (result) => result?.bookmark_state ?? undefined;
const getThreadAccess = (result) => result?.thread_access ?? undefined;
const getThreadSharedSlug = (result) => result?.thread_url_slug ?? undefined;
const getUpdatedDatetime = (result) => result?.updated_datetime ?? undefined;
const getExpiryTime = (result) => result?.expiry_time ?? null;
const getPrivacyState = (result) => result?.privacy_state ?? undefined;
export const socialInfoToStats = (social_info) => {
    return {
        forkCount: social_info?.fork_count ?? 0,
        likeCount: social_info?.like_count ?? 0,
        userLikes: social_info?.user_likes ?? false,
    };
};
const EMPTY_THREAD_METADATA = {};
export const createThreadMetadata = (result) => {
    if (!result) {
        return EMPTY_THREAD_METADATA;
    }
    return {
        author_id: getThreadAuthorId(result),
        author_image: getThreadAuthorImage(result),
        author_username: getThreadAuthorUsername(result),
        bookmarkState: getThreadBookmarkState(result),
        collection: getThreadCollection(result),
        contextUUID: getContextUUID(result),
        expiry_time: getExpiryTime(result) ?? undefined,
        first_query: getFirstQuery(result),
        focus: getThreadFocus(result),
        frontendContextUUID: getFrontendContextUUID(result),
        mode: getThreadMode(result) ?? undefined,
        parent_info: getThreadParentInfo(result) ?? undefined,
        personalized: getThreadPersonalized(result) ?? undefined,
        privacy_state: getPrivacyState(result) ?? undefined,
        rwToken: result.read_write_token,
        sources: getThreadSources(result) ?? undefined,
        text_completed: false,
        thread_access: getThreadAccess(result) ?? undefined,
        thread_url_slug: getThreadSharedSlug(result),
        title: getThreadTitle(result),
        updated_datetime: getUpdatedDatetime(result),
    };
};
//# sourceMappingURL=rwTokenUtils.js.map